import { h } from 'preact'
import Icon from '../assets'
import TextButton from '../ui-components/TextButton'
import axios from 'axios'

interface Props {
  articleId?: number | null,
  isPublic: boolean,
  onShowArticlePreviewModal: () => void,
  onError: ()=> void,
  onSuccess:(message: string)=> void
}

const displayMessage = {
  isPrivate: 'Only people with moderator role or above can preview via the link',
  isPublic: 'Anyone who has the preview link can access the preview without signing in'
}
const endpoints = {
  generatePreviewLink: '/draft/generatePreviewLink'
}
const ArticlePreviewSettings = (props: Props) => {
  async function getPreviewLink () : Promise<string> {
    let res
    try {
      res = await axios.post(endpoints.generatePreviewLink, {
        article_id: props.articleId
      })
    } catch (e) {
      props.onError()
    }
    return res?.data.link
  }

  async function onPreviewInCommunity () {
    const link = await getPreviewLink()
    window.open(link)
  }

  async function onCopyLink () {
    const link = await getPreviewLink()
    const tmp = document.createElement('textarea')
    tmp.value = link
    document.body.appendChild(tmp)
    tmp.select()
    document.execCommand('copy')
    document.body.removeChild(tmp)
    props.onSuccess('Preview link copied!')
  }

  return (
    <div className='article-creator__preview'>
      <div className='article-creator__preview-manage'>
        <div className='article-creator__preview-in-community'>
          <a className='qa-preview-in-community' onClick={onPreviewInCommunity}><span>Preview in community</span>&nbsp;<Icon icon='squareDiagonalArrow' width={9} height={9} /></a>
        </div>
        <div className='article-creator__copy-link'>
          <a className='qa-preview-copy-link' onClick={onCopyLink}>Copy link</a>
        </div>
      </div>
      <div className='article-creator__preview-display'>
        <div className='article-creator__preview-display-icon'><Icon icon='people' width={16} height={16} /></div>
        <div className='article-creator__preview-display-message'>{props.isPublic ? displayMessage.isPublic : displayMessage.isPrivate}
            &nbsp;(<TextButton class='article-creator__change-preview-button' onClick={props.onShowArticlePreviewModal}>change</TextButton>)
        </div>
      </div>
    </div>
  )
}

export default ArticlePreviewSettings
